<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item prop="operatorName">
        <el-input v-model="queryParams.operatorName"  placeholder="资源名称" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="operatorCode">
        <el-input v-model="queryParams.operatorCode"  placeholder="资源编码" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="countryName">
        <el-input v-model="queryParams.countryName"  placeholder="国家名称" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
      <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
    </el-form>
    <el-table v-loading="loading" :data="tableData" border>
      <el-table-column type="index" label="序号" align="center"></el-table-column>
      <el-table-column prop="operatorName" label="资源名称" align="center"  :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="englishName" label="资源英文名称" align="center" :show-overflow-tooltip="true"  ></el-table-column>
      <el-table-column prop="operatorCode" label="资源编码" align="center"  :show-overflow-tooltip="true"  >
        <template slot-scope="{row}">
          <el-tag v-if="!!row.operatorCode" type="success">{{row.operatorCode}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="countries" label="国家" align="center" width="600px">
          <template slot-scope="{row}">
            <div class="product-list">
              <div class="product-item" v-for="(item,index) in row.countries" :key="index" :title="item">
                    <span>{{item.name}}({{item.englishName}})</span>
              </div>
            </div>
          </template>
      </el-table-column>
      <el-table-column prop="roamLimit" label="区域限制" align="center" max-width="100" >
        <template slot-scope="{row}">
          <el-tag v-if="row.roamLimit == '00000'" type="info">无限制</el-tag>
          <el-tag v-else type="info">{{row.roamLimit}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" max-width="100" >
        <template slot-scope="{row}">
          <el-tag v-if="row.status == '1'" type="success">有效</el-tag>
          <el-tag v-else type="warning">无效</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" max-width="100" :show-overflow-tooltip="true"  ></el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" fixed="right" >
        <template v-slot:default="{row}">
          <el-button size="mini" type="text" icon="el-icon-edit" @click="handleEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />

    <el-dialog :title="title" :visible.sync="dialog" :lock-scroll="false" width="650px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="form" ref="form" :rules="rules"  label-width="140px">
        <el-form-item label="资源名称:" prop="operatorName" >
          <el-input v-model="form.operatorName" autocomplete="off" style="width: 80%" placeholder="请输入运营商名称"></el-input>
        </el-form-item>
        <el-form-item label="资源英文名称:" prop="englishName" >
          <el-input v-model="form.englishName" autocomplete="off" style="width: 80%" placeholder="请输入运营商英文名称"></el-input>
        </el-form-item>
        <el-form-item label="资源编码:" prop="operatorCode" >
          <el-input v-model="form.operatorCode" autocomplete="off" style="width: 80%" placeholder="请输入运营商编码"></el-input>
        </el-form-item>
        <el-form-item label="部署国家" prop="country">
          <el-checkbox v-model="countryNodeAll" @change="handleCheckedTreeNodeAll($event)" >全选/全不选</el-checkbox>
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText" 
            style="width: 80%">
          </el-input>
          <el-tree
            style="width: 80%"
            class="tree-border"
            :data="countryOptions"
            show-checkbox
            ref="menu"
            node-key="id"
            :filter-node-method="filterNode"
            empty-text="加载中，请稍候"
            :props="defaultProps"
          ></el-tree>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" v-model="form.remark" autocomplete="off" style="width: 80%" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancel">取消</el-button>
        <el-button type="success" @click="submit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { internationalSourcePage , internationalSourceSave , internationalSourceUpdate , countryList , selectCountryBySourceId} from "@/api/international.js";

export default {
  name: "internationalSource",
  data() {
    let validateCountry = (rule, value, callback) => {
      let checkedKeys = this.$refs.menu.getCheckedKeys();
      if (checkedKeys.length == 0) {
          callback(new Error('请选择国家'));
        } else {
          callback();
        }
    }
    return {
      // 查询条件
      queryParams: {
        operatorName:undefined,
        operatorCode:undefined,
        countryName:undefined,
      },
      // 遮罩层
      loading: true,
      // 分页器
      page: 1,
      pageSize: 10,
      total: 10,
      // 列表数据
      tableData: [],
      title:"新增运营商",
      dialog:false,
      form:{
        id:undefined,
        operatorName:undefined,
        englishName:undefined,
        operatorCode:undefined,
        countryIds:[],
        remark:undefined
      },
      rules: {
        operatorName: [
          { required: true, message: "资源名称不能为空", trigger: "blur" },
        ],
        englishName: [
          { required: true, message: "资源英文名称不能为空", trigger: "blur" },
        ],
        operatorCode: [
          { required: true, message: "资源编码不能为空", trigger: "blur" },
        ],
        country:[
          { validator: validateCountry, trigger: "blur" },
        ]
      },
      filterText:'',
      defaultProps: {
        label: "name"
      },
      countryNodeAll:false,
      //国家列表
      countryOptions:[]
    };
  },
  watch:{
    filterText(param){
      this.$refs.menu.filter(param);
    } 
  },
  methods: {
    // 添加
    handleAdd() {
        this.title = "新增资源"
        this.dialog = true
        this.selectCountrys()
        this.form ={
          id:undefined,
          operatorName:undefined,
          englishName:undefined,
          operatorCode:undefined,
          countryIds:[],
          remark:undefined
      }
    },
    // 编辑
    handleEdit(row){
        this.selectCountrys()
        Object.assign(this.form, row);
        selectCountryBySourceId({internationalSourceId:row.id}).then(res=>{
          this.$nextTick(() => {
            let checkedKeys = res.data.data
            if(checkedKeys.length>0 && this.countryOptions.length == checkedKeys.length){
              this.countryNodeAll = true
            }
            checkedKeys.forEach((v) => {
                this.$nextTick(()=>{
                    this.$refs.menu.setChecked(v, true ,false);
                })
            })
          });
        })
        this.title = "修改资源"
        this.dialog = true
    },
    // 搜索
    handleSearch() {
      this.initData();
    },
    // 获取列表
    initData() {
      this.loading=true;
      let params = {
        model:{
          ...this.queryParams
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      internationalSourcePage(params).then(res => {
        this.loading=false;
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    cancel(){
        this.dialog= false
        this.resetForm("form");
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    submit(){
        this.$refs.form.validate(valid => {
            if (valid) {
                this.form.countryIds = this.getMenuAllCheckedKeys();
                if(!!this.form.id){
                    internationalSourceUpdate(this.form).then(res=>{
                        this.cancel()
                        this.initData()
                    })
                }else{
                    internationalSourceSave(this.form).then(res=>{
                        this.cancel()
                        this.initData()
                    })
                }
            }
        })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value) {
      this.$refs.menu.setCheckedNodes(value ? this.countryOptions: []);
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.menu.getCheckedKeys();
      return checkedKeys;
    },
    selectCountrys(){
      countryList().then(res=>{
        this.countryOptions = res.data.data
      })
    }
  },
  mounted() {

  },
  created() {
    this.initData();
  },
};
</script>
<style scoped lang="less">
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 600px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 180px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
}
/deep/.tree-border {
  max-height: 32vh; /* 最大高度为视口高度的70%，可根据需求调整 */
  overflow-y: auto; /* 超出时显示垂直滚动条 */
  padding-top: 15px; /* 可选：调整内边距，优化布局 */
}

/deep/.tree-border::-webkit-scrollbar {
  width: 6px;
}
/deep/.tree-border::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
</style>
